// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import { TogglePreferences } from "./TogglePreferences";

// #####################################################

const ListItemAllowAction = ({ action, state, dispatch, noMarginBottom }) => {
	const { t } = useTranslation(["common", "userpanel"]);

	// #####################################################

	return (
		<TogglePreferences
			dispatchAction={() =>
				dispatch({
					type: "SET",
					field: `allow${action}`,
				})
			}
			toggled={state[`allow${action}`]}
			text={t(
				`userpanel:settings.preferences.allow.${action.toLowerCase()}`,
			)}
			noMarginBottom={noMarginBottom}
		/>
	);
};

// #####################################################

export default ListItemAllowAction;

// #####################################################
